'use strict';

import Chart from "chart.js";

function draw_slim_graph() {
    var ctx2 = document.getElementById("line_bar_graph").getContext('2d');
    window.horizontalBar = new Chart(ctx2, {
        type: 'horizontalBar',
        data: line_data,
        options: {
            barPercentage: 1,
            categoryPercentage: 1,
            barThickness: 500,
            scales: {
                xAxes: [{
                        stacked: true,
                        gridLines: {
                            display: false
                        },
                        display: false,
                    }],
                yAxes: [{
                        stacked: true,
                        gridLines: {
                            display: false
                        },
                        display: false,
                    }]
            },
            legend: {
                display: false,
            },
            tooltips: {
                enabled: false,
            },
        }
    });
}
(function ($) {

    var L10N = {
        'uk': {
            months: ['', 'січень', 'лютий', 'березень', 'квітень', 'травень',
                'червень', 'липень', 'серпень', 'вересень', 'жовтень',
                'листопад', 'грудень'],
            summ: 'Сума покупки',
        },
        'ru': {
            months: ['', 'январь', 'февраль', 'март', 'апрель', 'май',
                'июнь', 'июль', 'август', 'сентябрь', 'октябрь',
                'ноябрь', 'декабрь'],
            summ: 'Сумма покупки',
        },
    };

    var _token = $('meta[name="csrf-token"]').attr('content');

    function init() {

        var lang = document.documentElement.lang;

        // $('#user_card_list').chosen({
        //     width: '100%',
        //     disable_search: true,
        // });
        //
        // $('#user_card_list').on('change', function (evt, params) {
        //     alert(params.selected);
        // });


        if (document.getElementById("bonus_value_graph")) {
            var data = {
                datasets: [{
                        data: [89, 11],
                        backgroundColor: [
                            'rgba(132, 195, 67, 1)',
                            'rgba(255, 212, 3, 1)',
                        ],
                    }],
                // These labels appear in the legend and in the tooltips when hovering different arcs
                labels: [
                    'Green',
                    'Yellow',
                ],
                borderWidth: 0
            };


            var ctx = document.getElementById("bonus_value_graph").getContext('2d');
            var myDoughnutChart = new Chart(ctx, {
                type: 'doughnut',
                data: data,
                options: {
                    cutoutPercentage: 90,
                    legend: {
                        display: false,
                    },
                    tooltips: {
                        enabled: false,
                    },
                },
            });

        }

        if (document.getElementById("line_bar_graph")) {
            // line_bar_graph


            draw_slim_graph();
        }

        // history_graph


        /*
         function build_tooltop(tooltip) {

         // Tooltip Element
         var tooltipEl = document.getElementById('chartjs-tooltip');

         if (!tooltipEl) {
         tooltipEl = document.createElement('div');
         tooltipEl.id = 'chartjs-tooltip';
         tooltipEl.innerHTML = "<table></table>"
         this._chart.canvas.parentNode.appendChild(tooltipEl);
         }

         // Hide if no tooltip
         if (tooltip.opacity === 0) {
         tooltipEl.style.opacity = 0;
         return;
         }

         // Set caret Position
         tooltipEl.classList.remove('above', 'below', 'no-transform');

         if (tooltip.yAlign) {
         tooltipEl.classList.add(tooltip.yAlign);
         } else {
         tooltipEl.classList.add('no-transform');
         }


         function getBody(bodyItem) {
         return bodyItem.lines;
         }

         // Set Text
         if (tooltip.body) {
         var titleLines = tooltip.title || [];
         var bodyLines = tooltip.body.map(getBody);
         var innerHtml = '<thead>';

         titleLines.forEach(function(title) {
         innerHtml += '<tr><th>' + get_title(title) + '</th></tr>';
         });
         innerHtml += '</thead><tbody>';

         innerHtml += '<tr><td>' + get_header(bodyLines) + '</td></tr>';

         bodyLines.forEach(function(body, i) {
         var colors = tooltip.labelColors[i];
         var style = 'background:' + colors.backgroundColor;
         style += '; border-color:' + colors.borderColor;
         style += '; border-width: 2px';
         var span = '<span class="chartjs-tooltip-key" style="' + style + '"></span>';
         innerHtml += '<tr><td>' + span + body + ' грн</td></tr>';
         });

         innerHtml += '</tbody>';

         var tableRoot = tooltipEl.querySelector('table');
         tableRoot.innerHTML = innerHtml;
         }

         var positionY = this._chart.canvas.offsetTop;
         var positionX = this._chart.canvas.offsetLeft;


         console.log(tooltip);

         // Display, position, and set styles for font
         // tooltipEl.style.left = positionX + tooltip.caretX + 'px';
         // tooltipEl.style.top = positionY + tooltip.caretY + 'px';

         tooltipEl.style.left = tooltip.caretX  + 'px';
         tooltipEl.style.top = tooltip.caretY  + 'px';


         tooltipEl.style.opacity = 1;
         tooltipEl.style.fontFamily = tooltip._bodyFontFamily;
         tooltipEl.style.fontSize = tooltip.bodyFontSize + 'px';
         tooltipEl.style.fontStyle = tooltip._bodyFontStyle;
         tooltipEl.style.padding = tooltip.yPadding + 'px ' + tooltip.xPadding + 'px';
         }
         */

        // Custom Title
        function get_title(input) {
            var output = input.split('.');
            return L10N[lang].months[parseInt(output[0])] + ' ' + output[1]
            //   + L10N[lang].months[parseInt(output[1])]
            //  + ', 20' + output[2];
        }


        if (document.getElementById("history_graph")) {

            var ratio = 0.4691075514874142;
            var ctx3 = document.getElementById("history_graph").getContext('2d');
            window.histaryBar = new Chart(ctx3, {
                type: 'bar',
                data: history_data,
                options: {
                    scales: {
                        xAxes: [{
                                stacked: true,
                                barPercentage: 0.5
                            }],
                        yAxes: [{
                                stacked: true,
                            }]
                    },
                    responsive: true,
                    legend: {
                        display: true,
                        position: 'bottom',
                    },
                    tooltips: {
                        mode: 'index',
                        intersect: true,
                        //*
                        enabled: true,
                        backgroundColor: 'rgba(255, 255, 255, 1)',
                        titleFontSize: 14,
                        titleFontColor: '#000',
                        titleSpacing: 10,
                        // titleFontFamily: "'Open Sans', 'Helvetica', 'Arial', sans-serif",
                        bodyFontSize: 13,
                        bodyFontColor: '#000',
                        borderColor: 'rgba(0, 0, 0, 0.3)',
                        borderWidth: 1,
                        bodyFontFamily: "'Arial', 'Helvetica', sans-serif",
                        bodySpacing: 10,
                        xPadding: 10,
                        yPadding: 10,
                        callbacks: {
                            title: function (tooltipItem, chart) {
                                return get_title(tooltipItem[0].xLabel);
                            },
                            beforeBody: function (tooltipItem) {
                                var result = 0;
                                tooltipItem.forEach(function (body) {
                                    result += body.yLabel;
                                });
                                result = result.toString().replace('.', ',')
                                return L10N[lang].summ + ': ' + result + ' грн'
                            },
                            label: function (tooltipItem) {
                                return history_data.datasets[tooltipItem.datasetIndex].label
                                        + ': '
                                        + tooltipItem.yLabel.toString().replace('.', ',')
                                        + ' грн'
                            },
                        },
                        /*/
                         enabled: false,
                         custom: build_tooltop,
                         //*/
                    },
                }
            });
        }


        function send_data(start, end, stat_page) {
            var user_output = document.querySelector('.period-value');
            user_output.innerHTML = start + ' - ' + end;
            if (stat_page) {
                $.post('/stats_remote', {start: start, end: end, culture: lang, _token}, function (data) {
                    $('#stats_table').html(data);
                });
            } else {
                $.post('/get_user_chart', {start: start, end: end, lang : lang, culture: lang, _token}, function (data) {
                    $('#graph').html(data.chart);
                    window.horizontalBar.destroy();
                    draw_slim_graph();
                    $('#bonuses_used').html(data.sum + ' грн');
                });
            }
            //alert(`start: ${start}; end: ${end}`);
        }


        var date_selector = document.querySelector('.button_select_date');
        var extensionRange;

        if (date_selector) {
            date_selector.addEventListener('click', function () {
                if (!extensionRange) {
                    extensionRange = $('#date_range')
                            .datepicker('widget')
                            .data('datepickerExtensionRange');
                }
                var stat_page = false;
                if ($('#stat_list').length > 0) {
                    stat_page = true;
                }
                send_data(extensionRange.startDateText, extensionRange.endDateText, stat_page);

                document.querySelector('.data-period_active').classList.remove('data-period_active');
            });

            /* set date period */
            var date_filters = document.querySelectorAll('.calendar-item__btn');
            var i = 0;
            var len = date_filters.length;

            function set_date_filter_period(event){
                var self = event.currentTarget;
                var filter = self.dataset.value;

                var today;
                var year;
                var month;
                var start;
                var end;

                if (self.classList.contains('selected')) {
                    return;
                }

                today = new Date();
                year = today.getFullYear();
                month = today.getMonth();

                self.closest('.calendar-presets')
                        .querySelector('.selected')
                        .classList.remove('selected');

                self.classList.add('selected');

                if (filter === 'current_month') { // Поточний місяць
                    start = new Date(today.getFullYear(), today.getMonth(), 1);
                    end = '-1d';

                } else if (filter === 'last_month') { // Минулий місяць
                    start = new Date(today.getFullYear(), today.getMonth() - 1, 1);
                    end = new Date(today.getFullYear(), today.getMonth(), 1 - 1)

                } else if (filter === 'current_quarter') { // Поточний квартал
                    start = new Date(
                            today.getFullYear(),
                            parseInt((today.getMonth() / 3), 10) * 3,
                            1
                            );
                    end = '-1d';
                } else if (filter === 'last_quarter') { // Минулий квартал
                    start = new Date(
                            today.getFullYear(),
                            parseInt((today.getMonth() / 3), 10) * 3 - 3,
                            1
                            );
                    end = new Date(
                            today.getFullYear(),
                            parseInt((today.getMonth() / 3), 10) * 3,
                            1 - 1
                            );
                } else if (filter === 'current_year') { // Поточний рік
                    start = new Date(
                        today.getFullYear(),
                        0,
                        1
                    );
                    end = '-1d';
                } else if (filter === 'last_year') { // Минулий рік
                    start = new Date(
                        today.getFullYear() - 1,
                        0,
                        1
                    );
                    end = new Date(
                        today.getFullYear(),
                        0,
                        1 - 1
                    );;
                }

                $('#date_range').datepicker('setDate', [start, end]);

                if (!extensionRange) {
                    extensionRange = $('#date_range').datepicker('widget').data('datepickerExtensionRange');
                }

                if (extensionRange.startDateText)
                    $('[name=startDate]').val(extensionRange.startDateText);
                if (extensionRange.endDateText)
                    $('[name=endDate]').val(extensionRange.endDateText);
            }

            for (; i < len; i += 1) {
                date_filters[i].addEventListener('click', set_date_filter_period);
            }

            $('[name=startDate]').on('blur keyup', function(e) {
                if ( e.which === 13 || e.which === 0) {

                    let start = e.target.value,
                        end;

                    if (!extensionRange) {
                        extensionRange = $('#date_range').datepicker('widget').data('datepickerExtensionRange');
                    }

                    if (extensionRange.endDateText)
                        end = extensionRange.endDateText;

                    $('#date_range').datepicker('setDate', [start, end]);

                }
            })

            $('[name=endDate]').on('blur keyup', function(e) {
                if ( e.which === 13 || e.which === 0) {

                    let start,
                        end = e.target.value;

                    if (!extensionRange) {
                        extensionRange = $('#date_range').datepicker('widget').data('datepickerExtensionRange');
                    }

                    if (extensionRange.endDateText)
                        start = extensionRange.startDateText;

                    $('#date_range').datepicker('setDate', [start, end]);

                }
            })

        }

    }

    document.addEventListener('DOMContentLoaded', init);
}(jQuery));
